<section class="flex flex-col gap-4">
  <div
    class="flex gap-2 items-center w-full border-b border-gray-300 *:p-2.5 *:text-sm *:w-[12.5rem] *:border-gray-300"
  >
    <button
      routerLink="/receipt/list/summary"
      class="relative rounded border-b-0 border rounded-b-none rounded-bl-none rounded-br-none"
    >
      요약
      @if (segment() === 'summary') {
        <div class="bg-white h-px w-full absolute -bottom-[1px] right-0"></div>
      }
    </button>
    <button
      routerLink="/receipt/list/detail"
      class="relative rounded border-b-0 border rounded-b-none rounded-bl-none rounded-br-none"
    >
      상세 내역
      @if (segment() === 'detail') {
        <div class="bg-white h-px w-full absolute -bottom-[1px] right-0"></div>
      }
    </button>
    <button
      routerLink="/receipt/list/month"
      class="relative rounded border-b-0 border rounded-b-none rounded-bl-none rounded-br-none"
    >
      월별 내역
      @if (segment() === 'month') {
        <div class="bg-white h-px w-full absolute -bottom-[1px] right-0"></div>
      }
    </button>
  </div>
  <router-outlet />
</section>
